import script from "./LandingState.vue?vue&type=script&lang=ts&setup=true"
export * from "./LandingState.vue?vue&type=script&lang=ts&setup=true"

import "./LandingState.vue?vue&type=style&index=0&id=60dd3224&lang=scss"

const __exports__ = script;

export default __exports__